// ------------------------------------------------------------------------
// Basic colour values defined.
// Names are assigned with help of https://www.htmlcsscolor.com/hex/FFFFFF
// ------------------------------------------------------------------------

const FEDORA_GRAY = '#5b575c';
const MULLED_WINE_GRAY = '#59575c';
const LIGHT_GRAY = '#707070';
const MOBSTER = '#5a575c';
const WHISPER = '#eeeeee';
export const WHITE = '#fff';
const BAHIA_GREEN = '#a8bb30';
const FLAMINGO = '#ec605a';
const YELLOW_SEA = '#f39837';
const WILD_BLUE_YONDER = '#8085bd';
const TOPAZ = '#848285';
export const VERY_LIGHT_GRAY = '#cccccc';
const VIKING = '#41abc6';

// ------------------------------------------------------------------------
// Basic colours exposed to use across app and in components.
// ------------------------------------------------------------------------
export const APP_PRIMARY = MULLED_WINE_GRAY;
export const APP_SECONDARY = FEDORA_GRAY;
export const APP_TEXT_PRIMARY = FEDORA_GRAY;
export const APP_TEXT_SECONDARY = WHITE;
export const APP_SECTION_EAT_FRESH = BAHIA_GREEN;
export const APP_SECTION_STAY_ACTIVE = FLAMINGO;
export const APP_SECTION_BE_PRODUCTIVE = YELLOW_SEA;
export const APP_SECTION_REST = WILD_BLUE_YONDER;

// ------------------------------------------------------------------------
// Other necessary colours exposed to use across app and in components.
// ------------------------------------------------------------------------
export const FOOTER_TOP = TOPAZ;
export const FOOTER_BOTTOM = MOBSTER;
export const FOOTER_TEXT_PRIMARY = LIGHT_GRAY;
export const FOOTER_TEXT_SECONDARY = VERY_LIGHT_GRAY;
export const GENETIC_VARIATION_LINK_COLOR = VIKING;
